
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/designated-intractable-diseases-and-rare-diseases",
      function () {
        return require("private-next-pages/special/designated-intractable-diseases-and-rare-diseases/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/designated-intractable-diseases-and-rare-diseases"])
      });
    }
  